import apiService from 'src/enviroment'
import { loaderService } from 'src/services/loaderService'

const getMaterialesConCambio = async () => {
  loaderService.show()
  try {
    const response = await apiService.get('precios/materiales/?conCambio=1')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** F101: todo el catálogo activo, también las motos que Trade aún no pricea (`con_precio` = 0). */
const getMaterialesCatalogo = async () => {
  loaderService.show()
  try {
    const response = await apiService.get('precios/materiales/?todos=1')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** F103: borradores de bonos. accion = 'duplicar' (devuelve el id nuevo) | 'publicar'. */
const accionBorrador = async (id, accion) => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/promos/borrador/', { id, accion })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    // 400 con el motivo en el cuerpo (bono retirado, ya publicado…)
    if (error && error.response && error.response.data) return error.response.data
    return false
  } finally {
    loaderService.hide()
  }
}
const duplicarBono = (id) => accionBorrador(id, 'duplicar')
const publicarBono = (id) => accionBorrador(id, 'publicar')

const importarCatalogoSap = async () => {
  loaderService.show()
  try {
    // Hasta 5 min (el resto de llamadas corta a los 60 s): leer el catálogo de BigQuery puede tardar.
    const response = await apiService.post('precios/catalogo/import/', {}, { timeout: 300000 })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const registrarCambioMasivo = async (items) => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/cambio/masivo/', { items })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getPlano = async (estado = '') => {
  loaderService.show()
  try {
    const response = await apiService.get(`precios/plano/?estado=${estado}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const publicarPlano = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.put('precios/plano/publicar/', params)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const completarPlanoMasivo = async (items) => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/plano/masivo/', { items })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getSync = async () => {
  loaderService.show()
  try {
    const response = await apiService.get('precios/sync/')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const marcarSync = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.put('precios/sync/marcar/', params)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getSyncDetalle = async (material) => {
  try {
    const response = await apiService.get(`precios/sync/detalle/?material=${material}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

const getConfig = async () => {
  try {
    const response = await apiService.get('precios/config/')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

const setConfig = async (clave, valor) => {
  loaderService.show()
  try {
    const response = await apiService.put('precios/config/', { clave, valor })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const procesarSync = async () => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/sync/procesar/', {})
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** F104: las ciudades (municipios DANE) para la cobertura de los bonos: [{ ciudad, departamento, etiqueta }]. */
const getCiudades = async () => {
  try {
    const response = await apiService.get('precios/zonas/?ciudades=1')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

const getZonas = async () => {
  try {
    const response = await apiService.get('precios/zonas/')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

const getPromos = async () => {
  try {
    const response = await apiService.get('precios/promos/')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

/**
 * El catálogo de estrategias de bono (F59): las 11 del documento de Comercial y Financiación,
 * con el efecto que produce cada una según sea nacional o regional.
 */
const getBonoEstrategias = async () => {
  try {
    const response = await apiService.get('precios/promos/?estrategias=1')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

const registrarPromo = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/promos/', params)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    // El back rechaza con 400 y el motivo en el cuerpo: estrategia desconocida, monto en cero,
    // especie sin decir qué se entrega, cobertura inválida. Axios lo lanza como excepción, así
    // que hay que rescatarlo acá o el usuario recibe un 'no se pudo' sin saber qué corregir.
    const motivo = error && error.response && error.response.data && error.response.data.error
    if (motivo) return { success: 0, error: motivo }
    return false
  } finally {
    loaderService.hide()
  }
}

const marcarSinBono = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/promos/sinbono/', params)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const actualizarPromo = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.put('precios/promos/', params)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    // Igual que en el alta: el back rechaza con 400 y el motivo en el cuerpo (estrategia desconocida,
    // cobertura inválida, bono retirado, materiales que no se guardaron). `parcial` = los datos del
    // bono sí quedaron y falló el reemplazo de materiales.
    const cuerpo = error && error.response && error.response.data
    if (cuerpo && cuerpo.error) return { success: 0, error: cuerpo.error, parcial: Number(cuerpo.parcial) === 1 }
    return false
  } finally {
    loaderService.hide()
  }
}

/** F72: las motos de un bono con su cobertura y términos propios (vacío = heredan los del bono). */
const getBonoMateriales = async (reglaId) => {
  try {
    const response = await apiService.get(`precios/promos/materiales/?regla_id=${reglaId}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

/**
 * F72: guarda cobertura y términos por moto. items: [{ material, cobertura, legal }].
 * Devuelve { success, guardadas, total, data: [{ material, error }] }; con 400 (ninguna quedó) también
 * trae el detalle, para decir cuál falló.
 */
const setBonoMateriales = async (reglaId, items) => {
  loaderService.show()
  try {
    const response = await apiService.put('precios/promos/materiales/', { regla_id: reglaId, materiales: items })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    const cuerpo = error && error.response && error.response.data
    if (cuerpo && Array.isArray(cuerpo.data)) return cuerpo
    return false
  } finally {
    loaderService.hide()
  }
}

const subirImagenBono = async (imagen) => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/promos/imagen/', { imagen })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const retirarPromo = async (id) => {
  loaderService.show()
  try {
    const response = await apiService.delete(`precios/promos/?id=${id}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getAuditoria = async (desde = '', hasta = '') => {
  loaderService.show()
  try {
    const response = await apiService.get(`precios/auditoria/?desde=${desde}&hasta=${hasta}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const importVtex = async (items) => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/vtex/import/', { items })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getVtex = async () => {
  try {
    const response = await apiService.get('precios/vtex/')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

const getVtexPreview = async () => {
  try {
    const response = await apiService.get('precios/vtex/preview/')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

const getVtexEstado = async () => {
  try {
    const response = await apiService.get('precios/vtex/estado/')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

/** Endpoint público de bonos que consume Vtex; aquí se llama con la sesión, nunca con la api key. */
const getApiBonos = async (material = '', sku = '') => {
  try {
    const params = []
    if (material) params.push(`material=${encodeURIComponent(material)}`)
    if (sku) params.push(`sku=${encodeURIComponent(sku)}`)
    const response = await apiService.get(`precios/api/bonos/?${params.join('&')}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

const pushVtex = async () => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/vtex/push/', {})
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const notificarPendientes = async () => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/notificar/pendientes/', {})
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getResumen = async (desde = '', hasta = '') => {
  try {
    const response = await apiService.get(`precios/resumen/?desde=${desde}&hasta=${hasta}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

const getLista = async () => {
  try {
    const response = await apiService.get('precios/lista/')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

const enviarLista = async () => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/lista/enviar/', {})
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getDestinatarios = async () => {
  try {
    const response = await apiService.get('precios/destinatarios/')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

const crearDestinatario = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/destinatarios/', params)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const eliminarDestinatario = async (id) => {
  loaderService.show()
  try {
    const response = await apiService.delete(`precios/destinatarios/?id=${id}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

// ---------------------------------------------------------------------------------------------------
// F23/F24 — Motor de precios: conca (grupos), listas/condiciones SAP, clientes y cálculo del plano
// ---------------------------------------------------------------------------------------------------

/** Conca = modelo + año modelo + zona. Es donde vive el PVP; los colores lo heredan. */
const getGrupos = async () => {
  loaderService.show()
  try {
    const response = await apiService.get('precios/grupos/')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/**
 * Trade fija PVP + %IVA del MODELO (conca). El precio baja solo a todos sus colores y abre la cascada.
 * mes vacío = ciclo del mes actual (las cargas grandes son el día 1 de cada mes).
 */
/**
 * vigenteDesde (F37): 'YYYY-MM-DD' desde cuándo debe regir. Vacío = hoy (como siempre).
 * Con fecha futura el precio queda PROGRAMADO y el de hoy no se mueve hasta que llegue.
 */
/**
 * 'YYYY-MM-DDTHH:mm' (lo que da un input datetime-local) -> 'YYYY-MM-DD HH:mm:ss' (lo que espera MySQL).
 * Una fecha sola se completa: al inicio del dia si es el arranque, y al FINAL del dia si es el fin —
 * "hasta el 31" significa todo el 31, no las 00:00 del 31.
 */
const aDatetimeMysql = (v, finDeDia = false) => {
  const s = String(v || '').trim()
  if (!s) return ''
  const [fecha, hora] = s.split('T')
  if (!hora) return `${fecha} ${finDeDia ? '23:59:59' : '00:00:00'}`
  return `${fecha} ${hora}${hora.length === 5 ? ':00' : ''}`
}

const registrarPrecioGrupo = async (grupoId, pvp, ivaPct, mes = '', vigenteDesde = '', vigenteHasta = '') => {
  loaderService.show()
  try {
    const response = await apiService.put('precios/grupos/', {
      grupo_id: String(grupoId),
      pvp: String(pvp),
      // 0 es SIN IVA (eléctricas): no se puede convertir en vacío. Vacío = no indicado (se conserva el actual).
      iva_pct: ivaPct === null || ivaPct === undefined || ivaPct === '' ? '' : String(ivaPct),
      mes,
      vigente_desde: aDatetimeMysql(vigenteDesde),
      // vacio = no vence (precio de lista). Con fecha, el plano sale con esa fecha en la columna C.
      vigente_hasta: aDatetimeMysql(vigenteHasta, true),
    })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** Los colores (materiales) que cubre un modelo: se ven antes de tocar el precio. */
const getGrupoMateriales = async (grupoId) => {
  try {
    const response = await apiService.get(`precios/grupos/?grupo_id=${grupoId}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

/**
 * Márgenes de UNA moto: qué gana cada lista y a cuánto queda facturada.
 * Con `pvp` se simula el precio que Trade está tecleando, sin guardar nada.
 */
const getGrupoMargenes = async (grupoId, { vendedorId = 0, pvp = 0, ivaPct = -1 } = {}) => {
  try {
    // iva_pct: -1 = no indicado (usa el de la moto); 0 = SIN IVA, que es un valor válido.
    const iva = ivaPct === null || ivaPct === undefined || ivaPct === '' ? -1 : ivaPct
    const qs = `grupo_id=${grupoId}&vendedor_id=${vendedorId || 0}&pvp=${pvp || 0}&iva_pct=${iva}`
    const response = await apiService.get(`precios/grupos/margenes/?${qs}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

/** Fija el margen de esa lista para esa moto. valor < 0 = quitar la excepción. Versiona por ciclo. */
const setGrupoMargen = async ({ grupoId, listaId, valor, vendedorId = 0, mes = '', nota = '' }) => {
  loaderService.show()
  try {
    const response = await apiService.put('precios/grupos/margenes/', {
      grupo_id: String(grupoId),
      lista_id: String(listaId),
      vendedor_id: String(vendedorId || 0),
      valor: String(valor),
      mes,
      nota,
    })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/**
 * Envío del plano a SAP (f109, contrato Lucia <-> SAP). Arma un lote con las líneas calculadas de esas
 * motos, menos las clasificaciones excluidas, y manda un envío por tabla + condición.
 * Responde { success, lote_id, modo: 'simulado'|'real', envios: [...] } o { success: 0, error }.
 */
const enviarPlanoSap = async ({ grupos, excluidas = [] }) => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/plano/sap/', {
      grupos: (grupos || []).map(String),
      excluidas: (excluidas || []).map(String),
    })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** Los envíos a SAP de un lote o de una moto, con su estado. */
const getEnviosSap = async ({ loteId = 0, grupoId = 0 }) => {
  try {
    const response = await apiService.get(`precios/plano/sap/?lote_id=${loteId || 0}&grupo_id=${grupoId || 0}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

/** Las líneas que se mandaron en un envío, con lo que SAP rechazó y por qué. */
const getEnvioSapLineas = async (envioId) => {
  try {
    const response = await apiService.get(`precios/plano/sap/?envio_id=${encodeURIComponent(envioId)}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

/** Reintenta un envío: mismo envio_id y mismas líneas, así SAP no lo aplica dos veces. */
const reenviarEnvioSap = async (envioId) => {
  loaderService.show()
  try {
    const response = await apiService.put('precios/plano/sap/', { envio_id: envioId })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/**
 * Varios márgenes, de varias motos, en una sola llamada. Cada item es lo mismo que manda
 * setGrupoMargen (valor como fracción en texto). Responde una fila por item con su result/error:
 * si una falla, las otras quedan guardadas. El back acepta hasta 2000 items por envío; partir en
 * lotes es de quien llama.
 */
const setGrupoMargenesMasivo = async (items) => {
  loaderService.show()
  try {
    const response = await apiService.put('precios/grupos/margenes/masivo/', {
      items: (items || []).map((i) => ({
        grupo_id: String(i.grupo_id),
        lista_id: String(i.lista_id),
        valor: String(i.valor),
        ...(i.vendedor_id !== undefined ? { vendedor_id: String(i.vendedor_id || 0) } : {}),
        ...(i.mes ? { mes: i.mes } : {}),
        ...(i.nota ? { nota: i.nota } : {}),
      })),
    })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    // 400 con el motivo en el cuerpo ('[items] are required', 'máximo 2000 items por envío...').
    // Axios lo lanza como excepción: se rescata para que el aviso diga qué pasó.
    const cuerpo = error && error.response && error.response.data
    const motivo = cuerpo && (cuerpo.message || cuerpo.error)
    if (motivo) return { success: 0, error: motivo }
    return false
  } finally {
    loaderService.hide()
  }
}

/** Grupos de descuento (816 ZDPC) y si este modelo está marcado en cada uno. */
const getGrupoZdpc = async (grupoId) => {
  try {
    const response = await apiService.get(`precios/grupos/zdpc/?grupo_id=${grupoId}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

/** Marca o desmarca el modelo en un grupo de descuento (decisión comercial, no se infiere). */
const setGrupoZdpc = async (grupoId, listaId, incluida) => {
  loaderService.show()
  try {
    const response = await apiService.put('precios/grupos/zdpc/', {
      grupo_id: String(grupoId),
      lista_id: String(listaId),
      incluida: incluida ? '1' : '0',
    })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** Ciclos mensuales: la "tanda" de cada mes con su tamaño y variación promedio. */
const getCiclos = async () => {
  loaderService.show()
  try {
    const response = await apiService.get('precios/ciclos/')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** Detalle de un ciclo por modelo: precio al abrir vs vigente, y cuántas veces se tocó. */
const getCicloDetalle = async (mes) => {
  loaderService.show()
  try {
    const response = await apiService.get(`precios/ciclos/?mes=${encodeURIComponent(mes)}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** Catálogo de listas/condiciones SAP (todas=1 incluye las inactivas). */
const getListas = async (todas = false) => {
  loaderService.show()
  try {
    const response = await apiService.get(`precios/listas/${todas ? '?todas=1' : ''}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** Clientes con su lista y su margen negociado (1 fila por cliente x condición). */
const getClientes = async (texto = '') => {
  loaderService.show()
  try {
    const response = await apiService.get(`precios/clientes/?texto=${encodeURIComponent(texto)}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** Recalcula el plano de un conca: 1 PVP -> N líneas de carga SAP. */
const calcularPlano = async (grupoId, organizacion = '1000', planoId = 0) => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/plano/calculo/', {
      grupo_id: String(grupoId),
      organizacion,
      plano_id: String(planoId),
    })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

// ---------------------------------------------------------------------------------------------------
// F28 — Márgenes: la hoja PRECIOS del Excel, viva (moto x lista/cliente)
// ---------------------------------------------------------------------------------------------------

/**
 * Matriz de márgenes. Una fila por (moto x lista); el componente la pivotea a la forma del Excel.
 * vendedorId > 0 responde la otra pregunta: qué margen tiene ESE cliente en cada moto.
 */
const getMargenMatriz = async ({ marca = '', q = '', vendedorId = 0, limite = 60 } = {}) => {
  loaderService.show()
  try {
    const qs = `matriz=1&marca=${encodeURIComponent(marca)}&q=${encodeURIComponent(q)}`
      + `&vendedor_id=${vendedorId || 0}&limite=${limite}`
    const response = await apiService.get(`precios/margenes/?${qs}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** Marcas del catálogo, para filtrar la matriz (son 1109 modelos: no se traen todos). */
const getMarcas = async () => {
  try {
    const response = await apiService.get('precios/margenes/?marcas=1')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

/** Reglas de margen vigentes (globales, por marca, por modelo y por cliente) con su alcance. */
const getMargenes = async (vendedorId = 0) => {
  try {
    const response = await apiService.get(`precios/margenes/?vendedor_id=${vendedorId || 0}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

/** Alta/edición de una regla de margen (excepción por moto y/o cliente). */
const guardarMargen = async (datos) => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/margenes/', datos)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const eliminarMargen = async (id) => {
  loaderService.show()
  try {
    const response = await apiService.delete(`precios/margenes/?id=${id}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** Bandeja de Back agrupada por MOTO: solo lo que Trade mandó, una fila por modelo. */
const getPlanoGrupos = async (estado = 'pendiente') => {
  loaderService.show()
  try {
    const response = await apiService.get(`precios/plano/?agrupado=1&estado=${estado}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** Lo que Back devolvió a Trade, con el motivo. */
const getPlanoRechazados = async () => {
  try {
    const response = await apiService.get('precios/plano/?rechazados=1')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

/** Devolver el plano a Trade. No revierte precio: con F27 la propuesta nunca se aplicó. */
const rechazarPlano = async (id, motivo) => {
  loaderService.show()
  try {
    const response = await apiService.put('precios/plano/rechazar/', { id: String(id), motivo })
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** Líneas calculadas con las columnas del layout (col_A..col_F) en orden real de carga. */
const getPlanoLineas = async (grupoId, planoId = 0) => {
  loaderService.show()
  try {
    const response = await apiService.get(`precios/plano/calculo/?grupo_id=${grupoId}&plano_id=${planoId}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/* ---------------------------------------------------------------------------------------------------
 * Clasificación de clientes (F34): el único lugar donde se configura una condición SAP.
 * De una clasificación cuelgan su llave, su fórmula, su margen (global + excepciones) y sus socios.
 * ------------------------------------------------------------------------------------------------- */

/**
 * Detalle de una clasificación + el "así se calcula" con un PVP/IVA de prueba (no guarda nada).
 * grupoId (F35): la moto sobre la que se simula. El margen depende de la moto, así que sin ella el
 * backend solo puede usar el margen global y el número NO coincide con el que va a SAP; en ese caso
 * la fila vuelve con `es_generico = 1` para que la pantalla lo rotule.
 */
const getClasificacion = async (id, pvp = 0, iva = 0, grupoId = 0) => {
  try {
    const response = await apiService.get(
      `precios/clasificaciones/?id=${id}&pvp=${pvp || 0}&iva=${iva || 0}&grupo_id=${grupoId || 0}`,
    )
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

/** Socios que tienen esa clasificación asignada. */
const getClasificacionSocios = async (id) => {
  try {
    const response = await apiService.get(`precios/clasificaciones/?id=${id}&socios=1`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

/**
 * Alta/edición de una clasificación. La llave NO se manda: la arma el backend desde las dimensiones
 * marcadas (un espacio de más rompe la carga a SAP). Devuelve {result, error, llave_patron}.
 */
const guardarClasificacion = async (datos) => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/clasificaciones/', datos)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** Baja LÓGICA (activo = 0), reversible. Rebota si otra clasificación hereda su margen. */
const desactivarClasificacion = async (id) => {
  loaderService.show()
  try {
    const response = await apiService.delete(`precios/clasificaciones/?id=${id}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** Perfiles: DEPRECADOS como fuente de verdad, quedan como etiqueta de agrupación del socio. */
const getPerfiles = async () => {
  try {
    const response = await apiService.get('precios/clientes/?perfiles=1')
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  }
}

/** Alta/edición de la razón social del socio. */
const guardarCliente = async (datos) => {
  loaderService.show()
  try {
    const response = await apiService.post('precios/clientes/', datos)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** Le asigna (o actualiza) una clasificación al socio. margen vacío = usa el de la clasificación. */
const asignarClasificacion = async (datos) => {
  loaderService.show()
  try {
    const response = await apiService.put('precios/clientes/', datos)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

/** Le retira SOLO esa clasificación al socio (baja lógica + cierra vigencia). */
const retirarClasificacionCliente = async (vendedorListaId) => {
  loaderService.show()
  try {
    const response = await apiService.delete(`precios/clientes/?vendedor_lista_id=${vendedorListaId}`)
    if (response.status === 200) return response.data
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export {
  getMaterialesConCambio,
  getMaterialesCatalogo,
  duplicarBono,
  publicarBono,
  importarCatalogoSap,
  getGrupos,
  registrarPrecioGrupo,
  getGrupoMateriales,
  getGrupoMargenes,
  setGrupoMargen,
  setGrupoMargenesMasivo,
  enviarPlanoSap,
  getEnviosSap,
  getEnvioSapLineas,
  reenviarEnvioSap,
  getGrupoZdpc,
  setGrupoZdpc,
  getCiclos,
  getCicloDetalle,
  getListas,
  getClientes,
  getClasificacion,
  getClasificacionSocios,
  guardarClasificacion,
  desactivarClasificacion,
  getPerfiles,
  guardarCliente,
  asignarClasificacion,
  retirarClasificacionCliente,
  getMargenMatriz,
  getMarcas,
  getMargenes,
  guardarMargen,
  eliminarMargen,
  getPlanoGrupos,
  getPlanoRechazados,
  rechazarPlano,
  calcularPlano,
  getPlanoLineas,
  registrarCambioMasivo,
  getPlano,
  completarPlanoMasivo,
  publicarPlano,
  getSync,
  marcarSync,
  getSyncDetalle,
  getConfig,
  setConfig,
  procesarSync,
  getZonas,
  getCiudades,
  getPromos,
  registrarPromo,
  getBonoEstrategias,
  getBonoMateriales,
  setBonoMateriales,
  actualizarPromo,
  marcarSinBono,
  subirImagenBono,
  retirarPromo,
  getAuditoria,
  getResumen,
  notificarPendientes,
  importVtex,
  getVtex,
  getVtexPreview,
  getVtexEstado,
  getApiBonos,
  pushVtex,
  getLista,
  enviarLista,
  getDestinatarios,
  crearDestinatario,
  eliminarDestinatario,
}
